import {Controller} from 'stimulus';

export default class extends Controller {
  static targets = [];

  change(event) {
    window.location = this.element.selectedOptions[0].value;
  }
}
